/**
 * Değerlendirme read model (GET /evals/temsilci, v0.1.260): the Temsilci's reply evaluation runs and the newest run's
 * cases.
 */

import type { EvalOutcome } from '@twin/contracts';

export type { EvalCaseResult, EvalOutcome, EvalRun, EvalView } from '@twin/contracts';

export const EVAL_OUTCOME_LABELS: Readonly<Record<EvalOutcome, string>> = Object.freeze({
  passed: 'geçti',
  failed: 'kaldı',
  skipped: 'atlandı',
  error: 'hata',
});
